<template>
  <q-page class="container" padding>
    <div class="row col-12 justify-between items-center">
      <div class="col text-h6 text-brand-5 text-weight-bold">
        Editar Ferramenta
      </div>
      <div
        class="col-md-3"
        style="border: 2px solid black; border-radius: 10px"
      >
        <div
          :style="
            ferramenta.status == 'disponivel'
              ? 'background: #e8ffec; padding: 8px 5px;'
              : ferramenta.status == 'manutencao_garantia'
              ? 'background: #e6e6e6; padding: 8px 5px;'
              : ferramenta.status == 'uso'
              ? 'background: #fefed1; padding: 8px 5px;'
              : ferramenta.status == 'manutencao'
              ? 'background: #ffe9e9; padding: 8px 5px;'
              : ferramenta.status == 'em_transito'
              ? 'background:  #f8f8f8; padding: 8px 5px;'
              : ferramenta.status == 'removida' ||
                ferramenta.status == 'calibracao'
              ? 'background:  #9BA4B5; padding: 8px 5px;'
              : ferramenta.status == 'retorno_em_garantia'
              ? 'background:  #9BA4B5; padding: 8px 5px;'
              : ferramenta.status == 'desmobilizada'
              ? 'background:  #EDBC5A; padding: 8px 5px;'
              : ferramenta.status == 'reativacao'
              ? 'background:  #5178FF; padding: 8px 5px;'
              : ferramenta.status == 'descartada'
              ? 'background:  #EBEEFE; padding: 8px 5px;'
              : ferramenta.status == 'sucata'
              ? 'background:  #F3E8E0; padding: 8px 5px;'
              : ferramenta.status == 'furto'
              ? 'background:  #AB1D22; padding: 8px 5px;'
              : ferramenta.status == 'aguardando_reparo'
              ? 'background:  #EDBC5A; padding: 8px 5px;'
              : ferramenta.status == 'aguardando_calibracao'
              ? 'background:  #9BA4B5; padding: 8px 5px;'
              : ''
          "
          class="row col-12 no-wrap align items-center"
          style="border-radius: 10px"
        >
          <span
            v-if="ferramenta.status == 'disponivel'"
            class="elipse q-mr-sm bg-positive"
          ></span>
          <span
            v-if="ferramenta.status == 'uso'"
            class="elipse q-mr-sm bg-warning"
          ></span>
          <span
            v-if="ferramenta.status == 'manutencao_garantia'"
            class="elipse q-mr-sm"
            style="background: #424242"
          ></span>
          <span
            v-if="ferramenta.status == 'manutencao'"
            class="elipse q-mr-sm bg-red"
          ></span>
          <span
            v-if="ferramenta.status == 'em_transito'"
            class="elipse q-mr-sm"
            style="background: #2d3e6e"
          ></span>
          <span
            v-if="
              ferramenta.status == 'removida' ||
              ferramenta.status == 'calibracao'
            "
            class="elipse q-mr-sm"
            style="background: #383737"
          ></span>
          <span
            v-if="ferramenta.status == 'retorno_em_garantia'"
            class="elipse q-mr-sm"
            style="background: #383737"
          ></span>
          <span
            v-if="ferramenta.status == 'desmobilizada'"
            class="elipse q-mr-sm"
            style="background: #fa9726"
          ></span>
          <span
            v-if="ferramenta.status == 'reativacao'"
            class="elipse q-mr-sm"
            style="background: #473fe8"
          ></span>
          <span
            v-if="ferramenta.status == 'descartada'"
            class="elipse q-mr-sm"
            style="background: #b0cde8"
          ></span>
          <span
            v-if="ferramenta.status == 'sucata'"
            class="elipse q-mr-sm"
            style="background: #736d6a"
          ></span>
          <span
            v-if="ferramenta.status == 'furto'"
            class="elipse q-mr-sm"
            style="background: #6b1215"
          ></span>
          <span
            v-if="ferramenta.status == 'aguardando_reparo'"
            class="elipse q-mr-sm"
            style="background: #fa9726"
          ></span>
          <span
            v-if="ferramenta.status == 'aguardando_calibracao'"
            class="elipse q-mr-sm"
            style="background: #11009e"
          ></span>
          <div
            v-if="ferramenta.status == 'disponivel'"
            style="width: fit-content; background: #e8ffec; font-size: 16px"
            class="text-brand-5 text-bold"
          >
            {{ "Disponível" }}
          </div>
          <div
            v-if="ferramenta.status == 'uso'"
            style="width: fit-content; background: #fefed1; font-size: 16px"
            class="text-brand-5 text-bold"
          >
            {{ "Em Uso" }}
          </div>
          <div
            v-if="ferramenta.status == 'manutencao_garantia'"
            style="width: fit-content; font-size: 16px"
            class="text-brand-5 text-bold"
          >
            {{ "Manutenção Garantia" }}
          </div>
          <div
            v-if="ferramenta.status == 'manutencao'"
            style="width: fit-content; font-size: 16px"
            class="text-red text-bold"
          >
            {{ "Manutenção" }}
          </div>
          <div
            v-if="ferramenta.status == 'em_transito'"
            style="width: fit-content; color: #192957; font-size: 16px"
            class="text-bold"
          >
            {{ "Em Trânsito" }}
          </div>
          <div
            v-if="ferramenta.status == 'removida'"
            style="width: fit-content; font-size: 16px"
            class="text-bold"
          >
            {{ "Removida" }}
          </div>
          <div
            v-if="ferramenta.status == 'retorno_em_garantia'"
            style="width: fit-content; font-size: 16px"
            class="text-bold"
          >
            {{ "Retorno Em Garantia" }}
          </div>
          <div
            v-if="ferramenta.status == 'desmobilizada'"
            style="width: fit-content; font-size: 16px"
            class="text-bold"
          >
            {{ "Desmobilizada" }}
          </div>
          <div
            v-if="ferramenta.status == 'reativacao'"
            style="width: fit-content; font-size: 16px"
            class="text-bold"
          >
            {{ "Reativação" }}
          </div>
          <div
            v-if="ferramenta.status == 'descartada'"
            style="width: fit-content; font-size: 16px"
            class="text-bold"
          >
            {{ "Descartada" }}
          </div>
          <div
            v-if="ferramenta.status == 'sucata'"
            style="width: fit-content; font-size: 16px"
            class="text-bold"
          >
            {{ "Sucata" }}
          </div>
          <div
            v-if="ferramenta.status == 'furto'"
            style="width: fit-content; font-size: 16px"
            class="text-bold"
          >
            {{ "Furto" }}
          </div>
          <div
            v-if="ferramenta.status == 'aguardando_reparo'"
            style="width: fit-content; font-size: 16px"
            class="text-bold"
          >
            {{ "Aguardando Reparo" }}
          </div>
          <div
            v-if="ferramenta.status == 'calibracao'"
            style="width: fit-content; font-size: 16px"
            class="text-bold"
          >
            {{ "Calibração" }}
          </div>
          <div
            v-if="ferramenta.status == 'aguardando_calibracao'"
            style="width: fit-content; font-size: 16px"
            class="text-bold"
          >
            {{ "Aguardando Calibração" }}
          </div>
        </div>
      </div>
    </div>

    <q-form
      @submit.prevent="editarFerramenta"
      ref="myForm"
      class="q-pa-md q-mt-sm text-brand-5 text-weight-bold"
    >
      <div class="mobile-img" style="width: 15%">
        <q-img :src="ferramenta.url" fit="contain" spinner-color="white" />
        <q-file
          class="q-pt-md"
          style="width: 80%"
          dense
          outlined
          v-model="fileImg"
          label="Alterar imagem"
        />
      </div>
      <div class="row col q-col-gutter-sm mobile2" style="width: 80%">
        <div class="col-md-3 col-sm-12 col-xs-12">
          Código
          <q-input dense outlined v-model="ferramenta.nome"> </q-input>
        </div>
        <div class="col-md-3 col-sm-12 col-xs-12">
          Descrição da Ferramenta
          <q-input dense outlined v-model="ferramenta.descricao"> </q-input>
        </div>

        <div class="col-md-3 col-sm-12 col-xs-12">
          <SelectComponentGrupos
            @emitirGrupo="receberDadosGrupo"
            :subGrupoCategoriaUuid="subGrupo.categoriaUuid"
            :model="ferramenta.categoria_obj || ''"
          />
        </div>
        <div class="col-md-3 col-sm-12 col-xs-12">
          <SelectComponentSubGrupos
            @emitirSubGrupo="receberDadosSubGrupo"
            :categoriaUuid="categoria"
            :model="ferramenta.grupo_obj"
            :resetar="resetar"
            v-if="ferramenta.grupo_obj?.uuid"
          />
          <SelectComponentSubGrupos
            @emitirSubGrupo="receberDadosSubGrupo"
            :categoriaUuid="categoria"
            :resetar="resetar"
            v-else
          />
        </div>
        <div class="col-md-3 col-xs-12 col-sm-12">
          <SelectComponentFornecedores
            @emitirFornecedor="receberDadosFornecedor"
            :titulo="'Fornecedor'"
            :model="ferramenta.fornecedor"
          />
        </div>

        <div class="col-md-3 col-sm-12 col-xs-12">
          Série
          <q-input dense outlined v-model="ferramenta.serie"> </q-input>
        </div>

        <div class="col-md-3 col-sm-12 col-xs-12">
          Valor Equipamento
          <q-input
            mask="#,##"
            reverse-fill-mask
            dense
            outlined
            v-model="ferramenta.preco"
          >
          </q-input>
        </div>

        <div class="col-md-3 col-sm-12 col-xs-12">
          N. Patrimônio
          <q-input dense outlined v-model="ferramenta.patrimonio" type="text">
          </q-input>
        </div>
        <div class="col-md-3 col-sm-12 col-xs-12">
          N. Documento
          <q-input dense outlined v-model="ferramenta.documento"> </q-input>
        </div>
        <div class="col-md-3 col-sm-12 col-xs-12">
          Tempo de Permanência
          <q-input
            dense
            outlined
            v-model="ferramenta.tempoPermanencia"
            type="number"
          >
          </q-input>
        </div>
        <div class="col-md-3 col-sm-12 col-xs-12">
          Valor Locação
          <q-input
            mask="#,##"
            reverse-fill-mask
            dense
            outlined
            v-model="ferramenta.valorLocacao"
          >
          </q-input>
        </div>
        <div class="col-md-3 col-sm-12 col-xs-12">
          <SelectComponentTipoDocumento
            @enviarTipoDocumento="receberTipoDocumento"
            :value="ferramenta.tipoDocumento"
            v-if="ferramenta.tipoDocumento"
          />
          <SelectComponentTipoDocumento
            @enviarTipoDocumento="receberTipoDocumento"
            v-else
          />
        </div>
        <div class="col-md-3" v-if="ferramenta.responsavel">
          Selecione o Responsável
          <q-input dense outlined v-model="ferramenta.responsavel.nome">
          </q-input>
        </div>

        <div class="col-md-4 col-sm-12 col-xs-12">
          Origem
          <div class="row q-gutter-sm">
            <q-radio
              v-model="ferramenta.origem"
              val="Propria"
              label="Própria"
            ></q-radio>
            <q-radio
              v-model="ferramenta.origem"
              val="Locada"
              label="Locada"
            ></q-radio>
            <q-radio
              v-model="ferramenta.origem"
              val="Consumo"
              label="Consumo"
            ></q-radio>
          </div>
        </div>

        <div class="col-md-1 col-sm-12 col-xs-12">
          <p></p>
          <q-btn
            class="q-mt-sm full-width"
            color="primary"
            label="Salvar"
            v-on:click="editarFerramenta()"
          />
        </div>
      </div>
    </q-form>
    <div class="row col-12 items-center q-mt-xl">
      <div style="font-size: 18px" class="text-brand-5 text-weight-bold row">
        Gestão de Documentos Associados
      </div>
      <div>
        <q-btn
          label="Associar Documento"
          no-caps
          dense
          class="q-ml-md"
          color="brand-1"
          icon="description"
          outline
          @click="modalDocumentos = true"
        />
      </div>
    </div>

    <div v-if="listaDocumentosAssociados.length > 0" class="q-mb-lg">
      <q-table
        :columns="columns2"
        :rows="listaDocumentosAssociados"
        :loading="loading"
        color="primary"
        dense
        hide-bottom
        class="my-sticky-dynamic"
        no-data-label="Nenhum documento criado"
        flat
        row-key="uuid"
        table-header-class="bg-accent text-weight-bold"
        :rows-per-page-options="[0]"
        :filter="filtrarDocumentosAssociados"
      >
        <template v-slot:top-right>
          <q-input
            outlined
            dense
            rounded
            debounce="300"
            v-model="filtrarDocumentosAssociados"
            placeholder="Pesquisar"
          >
            <template v-slot:append>
              <q-icon name="search"></q-icon>
            </template>
          </q-input>
        </template>
        <template v-slot:header="props">
          <q-tr :props="props">
            <q-th v-for="col in props.cols" :key="col.name" :props="props">
              {{ col.label == "Associar" ? "Desassociar" : col.label }}
            </q-th>
          </q-tr>
        </template>
        <template v-slot:body="props">
          <q-tr class="text-brand-5 text-weight-bold">
            <q-td class="text-brand-5 text-weight-bold">
              {{ props.row.nome }}
            </q-td>
            <q-td class="text-brand-5 text-weight-bold">
              {{ props.row.descricao }}
            </q-td>
            <q-td class="text-brand-5 text-weight-bold">
              {{
                props.row.vigencia?.split(" ")[0].split("-").reverse().join("/")
              }}
            </q-td>
            <q-td class="text-brand-5 text-weight-bold">
              {{
                props.row.vencimento
                  ?.split(" ")[0]
                  .split("-")
                  .reverse()
                  .join("/")
              }}
            </q-td>
            <q-td class="text-brand-5 text-weight-bold">
              <div
                :style="
                  props.row.status == 'valido'
                    ? 'background: #e8ffec; width: fit-content; padding: 0px 5px'
                    : props.row.status == 'vencido'
                    ? 'background:#ffe9e9; color: #850202; width: fit-content; padding: 0px 5px'
                    : props.row.status == 'revalidado'
                    ? 'background:#fefed1; width: fit-content; padding: 0px 5px'
                    : props.row.status == 'inativo'
                    ? 'background:#9BA4B5; width: fit-content; padding: 0px 5px'
                    : ''
                "
                class="row col-12 items-center"
              >
                <div
                  v-if="props.row.status == 'valido'"
                  class="elipse-table q-mr-xs bg-positive"
                ></div>
                <div
                  v-if="props.row.status == 'revalidado'"
                  class="elipse-table q-mr-xs bg-warning"
                ></div>
                <div
                  v-if="props.row.status == 'vencido'"
                  class="elipse-table q-mr-xs"
                  style="background: red"
                ></div>
                <div
                  v-if="props.row.status == 'inativo'"
                  class="elipse-table q-mr-xs"
                  style="background: #383737"
                ></div>
                <span
                  v-if="props.row.status != 'inativo'"
                  class="row justify-center text-brand-5"
                >
                  {{
                    `${props.row.status
                      ?.substring(0, 1)
                      .toUpperCase()}${props.row.status?.substring(1)}`
                  }}
                </span>
                <span
                  v-if="props.row.status == 'inativo'"
                  class="row justify-center text-brand-5"
                >
                  Obsoleto
                </span>
              </div>
            </q-td>
            <q-td>
              <div class="row col-12 justify-center">
                <q-btn
                  icon="close"
                  color="red"
                  flat
                  round
                  :disable="disableToggleAssociacao"
                  @click="(confirm = true), (idDocumento = props.row.uuid)"
                />
              </div>
            </q-td>
          </q-tr>
        </template>
      </q-table>
    </div>
    <div
      v-else
      style="font-size: 16px"
      class="q-mt-sm q-ml-lg q-my-xl text-brand-5 text-weight-bold"
    >
      Nenhum documento associado
    </div>

    <div style="font-size: 18px" class="q-mt-md text-brand-5 text-weight-bold">
      Gestão de Anexos
    </div>
    <div class="row align col-12 q-mt-lg q-pb-lg">
      <div class="col-md-2 col-sm-12 col-xs-12 q-ma-sm">
        <q-file
          bg-color="primary"
          label-color="white"
          outlined
          v-model="file"
          label="Selecionar Arquivo"
        >
          <template v-slot:prepend>
            <q-icon name="file_upload" />
          </template>
        </q-file>
      </div>
      <div
        class="col-md-2 col-sm-8 col-xs-8 text-brand-5 text-weight-bold q-mb-md"
      >
        Observação
        <q-input dense outlined v-model="observacao" />
      </div>
      <div class="col-md-3 col-sm-3 col-xs-3 q-ml-sm">
        <q-btn
          class="q-mt-xs"
          dense
          label="Adicionar"
          icon="add_circle_outline"
          @click="onUpload()"
          color="primary"
        />
      </div>
    </div>

    <q-card flat>
      <div class="q-mt-lg">
        <div style="font-size: 18px" class="text-brand-5 text-weight-bold">
          Anexos
        </div>
        <q-table
          style="max-height: 50vh"
          id="customers"
          :rows="listaDocumentos"
          :columns="columns"
          dense
          :rows-per-page-options="[0]"
          hide-bottom
          flat
          :filter="filter"
          table-header-class="bg-accent text-weight-bold"
        >
          <template v-slot:top-right>
            <q-input
              outlined
              dense
              rounded
              debounce="300"
              v-model="filter"
              placeholder="Pesquisar"
            >
              <template v-slot:append>
                <q-icon name="search"></q-icon>
              </template>
            </q-input>
          </template>
          <template v-slot:body="props">
            <q-tr :props="props">
              <q-td class="text-left" key="uuid" :props="props">
                {{ props.row.uuid }}
              </q-td>
              <q-td class="text-left" key="observacao" :props="props">
                {{ props.row.observacao }}
              </q-td>
              <q-td class="text-left" key="data_criacao" :props="props">
                {{ props.row.created_at.date }}
              </q-td>
              <q-td class="text-left" key="url" :props="props">
                <a :href="props.row.url" download style="text-decoration: none">
                  <q-btn
                    color="white"
                    text-color="green"
                    round
                    icon="download"
                  />
                </a>
              </q-td>
              <q-td class="text-left">
                <q-btn
                  color="white"
                  text-color="red"
                  round
                  icon="remove_circle_outline"
                  @click="deletarDocumento(props.row.uuid)"
                />
              </q-td>
            </q-tr>
          </template>
        </q-table>
      </div>
    </q-card>
    <q-dialog v-model="modalDocumentos" full-width>
      <q-card style="height: 65vh">
        <q-card-section>
          <div class="row col-12 items-center justify-between">
            <div class="text-h6 col-6 text-brand-5 text-weight-bold">
              Documentos Criados
            </div>
            <div class="row col-6 justify-end">
              <div class="col-3">
                <q-input
                  rounded
                  outlined
                  dense
                  debounce="300"
                  placeholder="Pesquisar"
                  v-model="filtrarTabela"
                >
                  <template v-slot:append>
                    <q-icon name="search"></q-icon>
                  </template>
                </q-input>
              </div>
              <div class="col-4">
                <q-select
                  v-model="filtrosTabelaStatus"
                  :options="options.statusOptions"
                  multiple
                  dense
                  outlined
                />
              </div>
            </div>
          </div>
        </q-card-section>

        <div class="q-px-sm q-pt-none">
          <q-table
            :columns="columns2"
            :rows="listaDocumentosCriados"
            :loading="loading"
            color="primary"
            class="my-sticky-dynamic"
            hide-bottom
            dense
            row-key="uuid"
            selection="multiple"
            no-data-label="Nenhum documento criado"
            hide-pagination
            flat
            table-header-class="bg-accent text-weight-bold"
            v-model:selected="selected"
            :rows-per-page-options="[0]"
          >
            <template v-slot:header="props">
              <q-tr :props="props">
                <q-th
                  class="text-weight-bolder"
                  v-for="col in props.cols"
                  :key="col.name"
                  :props="props"
                >
                  {{ col.label }}
                </q-th>
              </q-tr>
            </template>
            <template v-slot:body="props">
              <q-tr class="text-brand-5 text-weight-bold">
                <q-td class="text-brand-5 text-weight-bold">
                  {{ props.row.nome }}
                </q-td>
                <q-td class="text-brand-5 text-weight-bold">
                  {{ props.row.descricao }}
                </q-td>
                <q-td class="text-brand-5 text-weight-bold">
                  {{
                    props.row.vigencia
                      ?.split(" ")[0]
                      .split("-")
                      .reverse()
                      .join("/")
                  }}
                </q-td>
                <q-td class="text-brand-5 text-weight-bold">
                  {{
                    props.row.vencimento
                      ?.split(" ")[0]
                      .split("-")
                      .reverse()
                      .join("/")
                  }}
                </q-td>
                <q-td class="text-brand-5 text-weight-bold">
                  <div
                    :style="
                      props.row.status == 'valido'
                        ? 'background: #e8ffec; width: fit-content; padding: 0px 5px'
                        : props.row.status == 'vencido'
                        ? 'background:#ffe9e9; color: #850202; width: fit-content; padding: 0px 5px'
                        : props.row.status == 'revalidado'
                        ? 'background:#fefed1; width: fit-content; padding: 0px 5px'
                        : props.row.status == 'inativo'
                        ? 'background:#9BA4B5; width: fit-content; padding: 0px 5px'
                        : ''
                    "
                    class="row col-12 align items-center"
                  >
                    <div
                      v-if="props.row.status == 'valido'"
                      class="elipse-table q-mr-xs bg-positive"
                    ></div>
                    <div
                      v-if="props.row.status == 'revalidado'"
                      class="elipse-table q-mr-xs bg-warning"
                    ></div>
                    <div
                      v-if="props.row.status == 'vencido'"
                      class="elipse-table q-mr-xs"
                      style="background: red"
                    ></div>
                    <div
                      v-if="props.row.status == 'inativo'"
                      class="elipse-table q-mr-xs"
                      style="background: #383737"
                    ></div>
                    <span
                      v-if="props.row.status != 'inativo'"
                      class="row justify-center text-brand-5"
                    >
                      {{
                        `${props.row.status
                          ?.substring(0, 1)
                          .toUpperCase()}${props.row.status?.substring(1)}`
                      }}
                    </span>
                    <span
                      v-if="props.row.status == 'inativo'"
                      class="row justify-center text-brand-5"
                    >
                      Obsoleto
                    </span>
                  </div>
                </q-td>
                <q-td>
                  <div class="row col-12 justify-center">
                    <q-toggle
                      v-model="props.selected"
                      :disable="disableToggleAssociacao"
                      @click="
                        vincularDesvincularDocumento(
                          props.row.uuid,
                          props.selected
                        )
                      "
                    />
                  </div>
                </q-td>
              </q-tr>
            </template>
          </q-table>
          <div
            v-if="listaDocumentosCriados.length > 9 || pagination.page > 1"
            class="row justify-start q-mt-md"
          >
            <q-pagination
              :disable="disable"
              v-model="pagination.page"
              color="brand-5"
              active-color="secondary"
              active-text-color="white"
              :max="pagesNumber"
              :max-pages="5"
              :boundary-numbers="false"
              :direction-links="true"
              size="sm"
            />
          </div>
        </div>
      </q-card>
    </q-dialog>
    <q-dialog v-model="confirm" persistent>
      <q-card class="q-pa-sm text-brand-5 text-weight-bolder">
        <q-card-section class="row items-center">
          <span class="q-ml-sm"
            >Você tem certeza que deseja desassociar esse documento?</span
          >
        </q-card-section>

        <q-card-actions align="right">
          <q-btn
            icon="cancel"
            no-caps
            dense
            outline
            label="Não"
            color="negative"
            v-close-popup
          />
          <q-btn
            no-caps
            dense
            outline
            label="Sim"
            color="positive"
            v-close-popup
            icon="check_circle_outline"
            @click="vincularDesvincularDocumento(idDocumento, true)"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </q-page>
</template>

<script>
import SelectComponentFornecedores from "../components/SelectComponentFornecedores.vue";
import SelectComponentGrupos from "../components/SelectComponentGrupos.vue";
import SelectComponentSubGrupos from "../components/SelectComponentSubGrupos.vue";
import SelectComponentTipoDocumento from "../components/SelectComponentTipoDocumento.vue";
import { onMounted, ref, watch, computed } from "vue";
import { useRoute } from "vue-router";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { useQuasar } from "quasar";

export default {
  name: "EditarFerramenta",
  components: {
    SelectComponentFornecedores,
    SelectComponentGrupos,
    SelectComponentSubGrupos,
    SelectComponentTipoDocumento,
  },

  setup() {
    const $q = useQuasar();
    const $route = useRoute();
    const uuid = $route.params.uuid;
    const router = useRouter();
    const myForm = ref(null);
    const store = useStore();
    const imageFile = ref("");
    const observacao = ref("");
    let file = ref(null);
    const listaDocumentos = ref([]);
    const fileImg = ref(null);
    const image64 = ref("");
    let modalDocumentos = ref(false);
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 6,
    });
    const tab = ref("associados");
    const documento = ref({
      uuid: "",
      observacao: "",
      data_criacao: "",
    });
    let confirm = ref(false);

    const subGrupo = ref({
      uuid: "",
      categoriaUuid: "",
    });

    let resetar = ref(0);
    const selected = ref([]);

    const ferramenta = ref({
      unidadeId: "",
      uuid: "",
      nome: "",
      descricao: "",
      imagem: "",
      grupo: "",
      serie: "",
      patrimonio: "",
      fornecedorId: "",
      documento: "",
      preco: "",
      responsavelId: "",
      origem: "",
      tempoPermanencia: "",
      status: "",
      grupo_obj: "",
      tipoDocumento: "",
      valorLocacao: "",
    });

    const columns = [
      {
        name: "uuid",
        label: "Uuid",
        field: "uuid",
        align: "left",
        sortable: true,
      },
      {
        name: "observacao",
        label: "Observação",
        field: "observacao",
        align: "left",
        sortable: true,
      },
      {
        name: "data_criacao",
        label: "Data de Envio",
        field: (row) => formataDataHora(row.data_criacao),
        align: "left",
        sortable: false,
      },
      {
        name: "url",
        label: "Download",
        field: "url",
        align: "left",
      },

      {
        name: "",
        label: "Remover",
        field: "",
        align: "left",
      },
    ];
    const columns2 = [
      {
        name: "nome",
        label: "Nome",
        align: "left",
        field: "nome",
      },
      {
        name: "descricao",
        label: "Descrição",
        align: "left",
        field: "descricao",
      },
      {
        name: "emissao",
        label: "Emissão",
        align: "left",
      },
      {
        name: "vencimento",
        label: "Vencimento",
        align: "left",
      },
      {
        name: "status",
        label: "Status",
        align: "left",
      },
      {
        name: "associar",
        label: "Associar",
        align: "center",
      },
    ];
    const categoria = ref("");
    const listaDocumentosCriados = ref([]);
    const filtrarTabela = ref("");
    const filtrarDocumentosAssociados = ref("");
    let loading = ref(false);
    let disable = ref(false);
    const idDocumento = ref("");
    let disableToggleAssociacao = ref(false);
    const listaDocumentosAssociados = ref([]);
    const filtrosTabelaStatus = ref([{ label: "Válido", value: "valido" }]);
    const options = ref({
      statusOptions: [
        { label: "Válido", value: "valido" },
        { label: "Vencido", value: "vencido" },
        { label: "Revalidado", value: "revalidado" },
        { label: "Obsoleto", value: "inativo" },
      ],
    });

    const formataDataHora = (data_criacao) => {
      const data = data_criacao.split(" ")[0].split("-").reverse().join("/");

      const hora = data_criacao.split(" ")[1].replace(".000000", "");

      return `${data} ${hora}`;
    };

    let onFileSelected = async (e) => {
      if (e.target.files[0].length === 0) {
        return;
      }

      imageFile.value = e.target.files[0];
    };

    watch(
      () => file.value,
      () => {
        let fileReader = new FileReader();

        fileReader.readAsDataURL(file.value);
        fileReader.addEventListener("load", () => {
          image64.value = fileReader.result;
        });
      }
    );

    let onUpload = async () => {
      if (file.value == null) {
        $q.notify({
          message: "Selecione um arquivo para fazer o upload.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      if (observacao.value == "") {
        $q.notify({
          message: "Preencha a observação para fazer um upload.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      await store.dispatch("fer/uploadDocumentos", {
        transaction_type: "ferramenta",
        transaction_uuid: uuid,
        observacao: observacao.value,
        imagem: image64.value,
      });

      mensagem("Arquivo enviado com sucesso!");
      observacao.value = "";
      image64.value = "";
      file.value = null;
      consultarFerramenta();
    };

    let consultarFerramenta = async () => {
      let resposta = await store.dispatch("fer/consultarFerramenta", {
        uuid: uuid,
      });
      ferramenta.value = resposta.resposta.result;
      subGrupo.value.categoriaUuid = ferramenta.value.categoria;
      categoria.value = ferramenta.value.categoria;
      listaDocumentos.value = await resposta.resposta.result.documentos;
    };

    let receberDadosFuncionario = async (value) => {
      ferramenta.value.responsavelId = value.value[0].id;
      ferramenta.value.responsavelNome = value.value[0].nome;
    };

    let consultarFuncionario = async () => {
      let resposta = await store.dispatch("funcionario/consultar", {
        funcionarioId: ferramenta.value.responsavelId,
      });
      ferramenta.value.responsavelNome = resposta.funcionario.nome;
    };

    let receberDadosFornecedor = async (value) => {
      ferramenta.value.fornecedorId = value.value.id;
    };

    let receberDadosGrupo = async (value) => {
      if (value == "") {
        categoria.value = "";
        subGrupo.value.categoriaUuid = "";
        return;
      }
      if (value == null) {
        return;
      }
      if (ferramenta.value.categoria == value.uuid) {
        categoria.value = ferramenta.value.categoria;
        return;
      }
      categoria.value = value.uuid;
    };

    const receberDadosSubGrupo = async (value) => {
      ferramenta.value.grupo = value.uuid;
      subGrupo.value.categoriaUuid = value.categoria_uuid;
    };

    const receberTipoDocumento = async (value) => {
      ferramenta.value.tipoDocumento = value;
    };

    let editarFerramenta = async () => {
      editarImg();
      try {
        await store.dispatch("fer/editarFerramenta", {
          uuid: ferramenta.value.uuid,
          unidadeId: 1,
          nome: ferramenta.value.nome,
          descricao: ferramenta.value.descricao,
          patrimonio: ferramenta.value.patrimonio,
          permanencia: ferramenta.value.tempoPermanencia,
          preco: ferramenta.value?.preco.split(",").join("."),
          grupo: ferramenta.value.grupo,
          origem: ferramenta.value.origem,
          serie: ferramenta.value.serie,
          documento: ferramenta.value.documento,
          fornecedorId: ferramenta.value.fornecedorId,
          responsavelId: ferramenta.value.responsavelId,
          status: ferramenta.value.status,
          tipo_documento: ferramenta.value.tipoDocumento,
          valor_locacao: ferramenta.value?.valorLocacao.split(",").join("."),
        });

        mensagem("Dados alterados!");
      } catch (e) {
        $q.notify({
          message: e.response.data.result.error,
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        if (e.response.data.result.error.includes("chave_unica_composta")) {
          $q.notify({
            message: `Ja existe uma ferramenta com a chave ${ferramenta.value.chaveUnicaComposta}.`,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }

        if (e.request.status >= 500) {
          $q.notify({
            message: "Erro no servidor, tente novamente",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      }

      router.push({ name: "cadastrarFerramenta" });
    };

    let deletarDocumento = async (uuid) => {
      let resposta = confirm(`Deseja realmente excluir o documento? `);
      if (resposta == true) {
        await store.dispatch("fer/deletarDocumento", {
          uuid: uuid,
        });
        consultarFerramenta();
        mensagem("Documento excluido com sucesso!");
      }
    };

    let mensagem = (mensagem) => {
      $q.notify({
        message: mensagem,
        color: "positive",
        actions: [
          {
            label: "Fechar",
            color: "white",
            handler: () => {
              /* ... */
            },
          },
        ],
      });
    };

    let executar = async () => {
      await consultarFerramenta();
      await consultarFuncionario();
    };

    const listarDocumentos = async (page = 0, rowsNumber = 100) => {
      let array = [];
      filtrosTabelaStatus.value?.forEach((status) => {
        array.push(status.value);
      });
      try {
        loading.value = true;
        disable.value = true;
        const response = await store.dispatch("fer/listarDocumentosCriados", {
          unidadeId: store.state.org.unidadeData.id,
          nome: filtrarTabela.value,
          page: page,
          perPage: rowsNumber,
          status: array.slice().join(",") || undefined,
        });
        listaDocumentosCriados.value = response.data.resultado.dados;
        pagination.value.rowsPerPage = response.data.resultado.perPage;
        pagination.value.page = response.data.resultado.currentPage;
        pagination.value.rowsNumber = response.data.resultado.total;
        loading.value = false;
        disable.value = false;
      } catch (error) {
        console.log(error);
      }
    };

    const listarDocumentosAssociados = async (page = 0, rowsNumber = 100) => {
      try {
        const response = await store.dispatch("fer/listarDocumentosCriados", {
          unidadeId: store.state.org.unidadeData.id,
          nome: filtrarTabela.value,
          page: page,
          perPage: rowsNumber,
          vinculadoId: uuid,
          origemVinculo: "ferramenta",
        });
        listaDocumentosAssociados.value = response.data.resultado.dados;
        selected.value = response.data.resultado.dados;
      } catch (error) {
        console.log(error);
      }
    };

    const vincularDesvincularDocumento = async (uuidDocumento, acao) => {
      disableToggleAssociacao.value = true;
      if (!acao) {
        try {
          await store.dispatch("fer/vincularDocumento", {
            origem: "ferramenta",
            documentoUuid: uuidDocumento,
            vinculados: [{ id: uuid }],
          });
          disableToggleAssociacao.value = false;
          listarDocumentosAssociados();
          $q.notify({
            message: "Documento Associado com sucesso.",
            color: "positive",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        } catch (error) {
          listarDocumentosAssociados();
          if (error.response.data.erro.mensagem === "Recurso não autorizado!") {
            $q.notify({
              message: "Você não tem permissão para executar a ação.",
              color: "negative",
              actions: [
                {
                  label: "Fechar",
                  color: "white",
                  handler: () => {
                    /* ... */
                  },
                },
              ],
            });
            disableToggleAssociacao.value = false;
            return;
          }
          $q.notify({
            message: error.response.data.erro.mensagem,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          disableToggleAssociacao.value = false;
        }
      } else {
        try {
          await store.dispatch("fer/desvincularDocumento", {
            origem: "ferramenta",
            documentoUuid: uuidDocumento,
            vinculados: [{ id: uuid }],
          });
          disableToggleAssociacao.value = false;
          listarDocumentosAssociados();
          $q.notify({
            message: "Documento desassociado com sucesso.",
            color: "positive",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        } catch (error) {
          listarDocumentosAssociados();
          $q.notify({
            message: error.response.data.erro.mensagem,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          disableToggleAssociacao.value = false;
        }
      }
    };

    onMounted(() => {
      executar();
      listarDocumentos();
      listarDocumentosAssociados();
    });

    const editarImg = async () => {
      if (fileImg.value == null) {
        return;
      }
      try {
        let fileReader = new FileReader();
        fileReader.readAsDataURL(fileImg.value);
        fileReader.addEventListener("load", () => {
          store.dispatch("fer/uploadImagem", {
            uuid: ferramenta.value.uuid,
            imagem: fileReader.result,
          });
        });
      } catch (error) {
        console.log(error);
      }
    };

    watch(
      () => filtrarTabela.value,
      () => {
        listarDocumentos();
      }
    );

    watch(
      () => filtrosTabelaStatus.value,
      () => {
        listarDocumentos();
      }
    );

    watch(
      () => modalDocumentos.value,
      () => {
        filtrarTabela.value = "";
      }
    );

    return {
      columns2,
      ferramenta,
      myForm,
      consultarFerramenta,
      editarFerramenta,
      selecionaFuncionario: ref(false),
      receberDadosGrupo,
      receberDadosFuncionario,
      receberDadosFornecedor,
      onUpload,
      onFileSelected,
      deletarDocumento,
      observacao,
      mensagem,
      columns,
      documento,
      listaDocumentos,
      formataDataHora,
      file,
      image64,
      fileImg,
      editarImg,
      filter: ref(""),
      receberDadosSubGrupo,
      subGrupo,
      resetar,
      categoria,
      receberTipoDocumento,
      modalDocumentos,
      pagination,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      listaDocumentosCriados,
      tab,
      filtrarTabela,
      loading,
      disable,
      selected,
      filtrarDocumentosAssociados,
      confirm,
      idDocumento,
      listarDocumentosAssociados,
      vincularDesvincularDocumento,
      disableToggleAssociacao,
      listaDocumentosAssociados,
      filtrosTabelaStatus,
      options,
    };
  },
};
</script>

<style scoped>
.elipse {
  width: 15px !important;
  height: 15px !important;
  border-radius: 100%;
}
.q-table__top,
thead tr:first-child th {
  background-color: #eef3fe;
}

thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:first-child th {
  top: 0;
}

.q-table--loading thead tr:last-child th {
  top: 48px;
}
.my-sticky-dynamic {
  max-height: 400px;
}
thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:last-child th {
  top: 48px;
}
thead tr:first-child th {
  top: 0;
}
.elipse-table {
  width: 11px !important;
  height: 11px !important;
  border-radius: 100px;
  margin: 0px 3px 2px 0px;
}
.q-form {
  display: flex;
}

.q-img {
  width: 80%;
  height: 80%;
  border: 1px solid #b4b4b4;
  border-radius: 5px;
}

.file {
  background-color: #58afc1;
}

.align {
  align-items: center;
}

@media (max-width: 1629px) {
  .mobile2 {
    width: 100% !important;
  }
}
@media (max-width: 600px) {
  .mobile-img {
    display: none;
  }
}
</style>
